import axios from "@/plugins/axios";

let url = "/api/v1/gshop/charges";

export default {
    get(data){
        return axios.get(`${url}/${data._id}`, data).then(result => result.data);
    },
}
